import { useState } from "react";
import "./editorialForms.css";

export default function GameReviewForm({ data, onChange }) {
  const [proInput, setProInput] = useState("");
  const [conInput, setConInput] = useState("");

  const platforms = [
    "PC",
    "PlayStation 5",
    "PlayStation 4",
    "Xbox Series X|S",
    "Xbox One",
    "Nintendo Switch",
    "Mobile",
    "Steam Deck",
  ];

  const difficulties = [
    { id: "easy", name: "Facil" },
    { id: "medium", name: "Medio" },
    { id: "hard", name: "Dificil" },
    { id: "very_hard", name: "Muito Dificil" },
  ];

  const recommendations = [
    { id: "essential", name: "Essencial", color: "#10b981" },
    { id: "recommended", name: "Recomendado", color: "#3b82f6" },
    { id: "mixed", name: "Misto", color: "#f59e0b" },
    { id: "not_recommended", name: "Nao Recomendado", color: "#ef4444" },
  ];

  const handlePlatformToggle = (platform) => {
    const currentPlatforms = data?.platform || [];
    if (currentPlatforms.includes(platform)) {
      onChange({
        ...data,
        platform: currentPlatforms.filter((p) => p !== platform),
      });
    } else {
      onChange({
        ...data,
        platform: [...currentPlatforms, platform],
      });
    }
  };

  const handleAddPro = () => {
    if (proInput.trim()) {
      onChange({
        ...data,
        pros: [...(data?.pros || []), proInput.trim()],
      });
      setProInput("");
    }
  };

  const handleAddCon = () => {
    if (conInput.trim()) {
      onChange({
        ...data,
        cons: [...(data?.cons || []), conInput.trim()],
      });
      setConInput("");
    }
  };

  const handleRemovePro = (index) => {
    onChange({
      ...data,
      pros: (data?.pros || []).filter((_, i) => i !== index),
    });
  };

  const handleRemoveCon = (index) => {
    onChange({
      ...data,
      cons: (data?.cons || []).filter((_, i) => i !== index),
    });
  };

  return (
    <div className="editorial_form game_review_form">
      <div className="editorial_form_section">
        <label>
          Nome do Jogo <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Ex: The Legend of Zelda: Tears of the Kingdom"
          value={data?.game || ""}
          onChange={(e) => onChange({ ...data, game: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Plataformas</label>
        <div className="genre_chips">
          {platforms.map((platform) => (
            <span
              key={platform}
              className={`genre_chip ${
                (data?.platform || []).includes(platform) ? "selected" : ""
              }`}
              onClick={() => handlePlatformToggle(platform)}
            >
              {platform}
            </span>
          ))}
        </div>
      </div>

      <div className="editorial_form_section">
        <label>
          Nota (0-10) <span className="required">*</span>
        </label>
        <input
          type="number"
          min="0"
          max="10"
          step="0.5"
          placeholder="8.5"
          value={data?.rating || ""}
          onChange={(e) =>
            onChange({ ...data, rating: parseFloat(e.target.value) || 0 })
          }
        />
      </div>

      <div className="editorial_form_section">
        <label>
          Pontos Positivos
          <button
            type="button"
            className="add_variant_btn"
            onClick={handleAddPro}
          >
            + Adicionar
          </button>
        </label>
        <input
          type="text"
          placeholder="Ex: Graficos incriveis"
          value={proInput}
          onChange={(e) => setProInput(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && handleAddPro()}
        />
        <div className="pros_cons_list">
          {(data?.pros || []).map((pro, i) => (
            <div key={i} className="pro_item">
              <span>+ {pro}</span>
              <button type="button" onClick={() => handleRemovePro(i)}>
                x
              </button>
            </div>
          ))}
        </div>
      </div>

      <div className="editorial_form_section">
        <label>
          Pontos Negativos
          <button
            type="button"
            className="add_variant_btn"
            onClick={handleAddCon}
            style={{ background: "#ef4444" }}
          >
            + Adicionar
          </button>
        </label>
        <input
          type="text"
          placeholder="Ex: Tempo de carregamento longo"
          value={conInput}
          onChange={(e) => setConInput(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && handleAddCon()}
        />
        <div className="pros_cons_list">
          {(data?.cons || []).map((con, i) => (
            <div key={i} className="con_item">
              <span>- {con}</span>
              <button type="button" onClick={() => handleRemoveCon(i)}>
                x
              </button>
            </div>
          ))}
        </div>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Dificuldade</label>
          <select
            value={data?.difficulty || ""}
            onChange={(e) => onChange({ ...data, difficulty: e.target.value })}
          >
            <option value="">Selecione</option>
            {difficulties.map((diff) => (
              <option key={diff.id} value={diff.id}>
                {diff.name}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>Tempo de Jogo (horas)</label>
          <input
            type="number"
            placeholder="Ex: 50"
            value={data?.playTime || ""}
            onChange={(e) =>
              onChange({ ...data, playTime: parseInt(e.target.value) || 0 })
            }
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Recomendacao</label>
        <div className="genre_chips">
          {recommendations.map((rec) => (
            <span
              key={rec.id}
              className={`genre_chip ${
                data?.recommendation === rec.id ? "selected" : ""
              }`}
              style={{
                "--chip-color": rec.color,
                background:
                  data?.recommendation === rec.id ? rec.color : undefined,
                borderColor:
                  data?.recommendation === rec.id ? rec.color : undefined,
              }}
              onClick={() => onChange({ ...data, recommendation: rec.id })}
            >
              {rec.name}
            </span>
          ))}
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Veredito Final</label>
        <textarea
          placeholder="Resuma sua opiniao sobre o jogo..."
          value={data?.verdict || ""}
          onChange={(e) => onChange({ ...data, verdict: e.target.value })}
          rows={3}
          maxLength={500}
        />
        <span className="editorial_form_counter">
          {(data?.verdict?.length || 0)}/500
        </span>
      </div>

      <div className="editorial_form_tip game_review_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
        </svg>
        <span>
          Compartilhe sua analise detalhada do jogo. Inclua pontos positivos e
          negativos para ajudar outros jogadores.
        </span>
      </div>
    </div>
  );
}
